import { render, staticRenderFns } from "./customer-case.vue?vue&type=template&id=70433305&scoped=true&"
import script from "./customer-case.vue?vue&type=script&lang=js&"
export * from "./customer-case.vue?vue&type=script&lang=js&"
import style0 from "./customer-case.vue?vue&type=style&index=0&id=70433305&prod&lang=less&"
import style1 from "./customer-case.vue?vue&type=style&index=1&id=70433305&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70433305",
  null
  
)

export default component.exports